import { Button, Grid, IconButton, Paper, Tooltip, Typography } from '@material-ui/core';
import React, { Component } from 'react';
import * as Gserv from '../services/GatewayService';
import {SettingsTwoTone, FileCopyTwoTone} from '@material-ui/icons';

export default class AccessToken extends Component {
    
    constructor(props) {
        super(props);
        this.initial_state = {
            selectedFile: null,
            button_caption: "Request Access Token",
            button_enabled: true,
            // data: null,
            // fields: null,
            // records_found: null,
            // failed_field_check: false,
            // missing_fields: [],
            error: false,
            error_message: "",
            // show_bad_records: false,
            // bad_records: [],
            show_spinner: false,
            // rom_codes_missing: false,
        }
        this.state=this.initial_state;
    }
 
    requestToken = () => {
        this.setState({show_spinner:true, button_enabled: false});
        Gserv.sendCommand('create_access_token',this.props.gwt)
        .then(reply => {
            // console.log('create_access_token reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (create_access_token) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",show_spinner:false});
            } else if (reply.Result!=="Success"){
                //check
                console.log('error on return from Gserv (create_access_token) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",show_spinner:false});
            } else {
                this.props.setParentState({access_token:reply.Token});                
                this.setState({show_spinner:false});
            }
        });
    }

    resetMe = () => {
        this.setState(this.initial_state);
    }

    copyMe = () => {
        navigator.clipboard.writeText(this.props.access_token);
    }
    
    render() {
        return (
            <Grid
                container
                direction='column'
                justifyContent='center'
                alignContent='center'
                // style={{backgroundColor:'yellow'}}
            >
            
                <Grid item>
                <Paper
                    elevation={3}
                    style={{
                        width:650
                    }}
                >
                    <Typography
                        style={{paddingTop:15}}
                    >
                        Generate Access Token for Excel Power Query
                    </Typography> 
                    <hr/>
                    
                        
                    {this.state.show_spinner&&
                    <span>
                        <SettingsTwoTone className='icn-spinner'/>&nbsp;
                    </span>}

                    {this.props.access_token&&
                    <div>
                        <Typography>
                            <i>Today's Access Token</i>
                        </Typography>
                        <Typography
                            color="primary"
                            variant='h6'
                            style={{
                                marginBottom:15,
                                marginTop:15,
                                paddingBottom:15,
                                paddingTop:15,
                                borderStyle:'solid',
                                borderWidth: 2
                            }}
                        >
                            {this.props.access_token}
                            <Tooltip title='Copy to Clipboard'>
                                <IconButton
                                    onClick={this.copyMe}
                                    style={{marginLeft:10}}
                                >
                                    <FileCopyTwoTone/>
                                </IconButton>
                            </Tooltip>
                        </Typography>
                    </div>}

                    {!this.props.access_token&&
                    <Button 
                        variant="contained"
                        color='primary'
                        component="span"
                        disabled={this.state.button_enabled? false : true}
                        onClick={this.requestToken}
                        style={{marginBottom:15}}
                    >
                        {this.state.button_caption}
                    </Button>}

                </Paper>
                </Grid>
            
                <Grid item>
                    <Typography color='secondary' style={{Width:650,maxWidth:650, textAlign:'center'}}>{this.state.error_message}</Typography>
                    {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
                </Grid>

            </Grid>
        );
    }

}